import { useContext, useEffect, lazy, Suspense } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';
import { Router } from 'react-router-dom';
import ImageSlider from './ImageSlider';
import MediaContainer from './MediaContainer';

const ReturnButton = lazy(() => import('./ReturnButton'));

const ObjectHero = () => {
  const { setMediaView, setMediaOption, objectId, estate, mediaView } =
    useContext(ObjectPageContext);

  return (
    <Router location={''} navigator={undefined}>
      {estate?.projectId && (
        <Suspense fallback={<></>}>
          <ReturnButton
            link={`/till-salu?objectId=${estate?.projectId}`}
            label="Till projektet"
          />
        </Suspense>
      )}
      <ImageSlider />
      {mediaView && <MediaContainer />}
    </Router>
  );
};

export default ObjectHero;
